import React from 'react';
import {RequestDto} from '../dtos/RequestDto';
import {Col, Layout, Row, Table} from 'antd';
import {ColumnsType} from "antd/es/table";
import ReactJson from 'react-json-view';
import {MethodTag} from "./MethodTag";

interface RequestInfoInterface {
    data: RequestDto;
}

interface Record {
    title: string;
    dataIndex: string;
}

interface Columns {
    key: string;
    value: string;
}

const { Content } = Layout;

const columns: ColumnsType<Columns> = [
    {
        dataIndex: 'key',
    },
    {
        dataIndex: 'value',
        render: (key: string, record: Columns) => {
            if (record.key === 'Method') {
                return <MethodTag method={record.value} />
            }
            if (record.key === 'IP') {
                return <a target="_blank" href={`https://who.is/whois-ip/ip-address/${record.value}`}>{record.value}</a>
            }
            if (record.key === 'URL') {
                return <a target="_blank" href={record.value}>{record.value}</a>
            }

            return record.value
        }
    },
]

const rows: Record[] = [
    {
        title: 'ID',
        dataIndex: 'id',
    },
    {
        title: 'Method',
        dataIndex: 'method',
    },
    {
        title: 'Path',
        dataIndex: 'path',
    },
    {
        title: 'URL',
        dataIndex: 'url',
    },
    {
        title: 'Status',
        dataIndex: 'status',
    },
    {
        title: 'IP',
        dataIndex: 'ip',
    },
    {
        title: 'Date',
        dataIndex: 'time',
    },
];

export const RequestInfo: React.FC<RequestInfoInterface> = ({ data }) => {
    const info: Columns[] = [];
    //@ts-ignore
    rows.map(item => info.push({ key: item.title, value: data[item.dataIndex] }))

    return <Content style={{ overflow: 'initial'}}>
        <div className="site-layout-background" style={{padding: 24, textAlign: 'center'}}>
            <Row gutter={[8, 8]}>
                <Col span={12}>
                    <Table
                        size={"small"}
                        columns={columns}
                        dataSource={info}
                        bordered
                        title={() => 'Info'}
                        showHeader={false}
                        pagination={false}
                    />

                    <div style={{
                        textAlign: 'left',
                        display: 'block',
                        fontFamily: 'monospace',
                        position: 'relative',
                        padding: '10px',
                        margin: '10px 0px'
                    }}>
                        <ReactJson src={data.headers} name="headers" iconStyle="square" enableClipboard={false} collapsed={1} collapseStringsAfterLength={40}/>
                    </div>
                    {data.queryParams && Object.keys(data.queryParams).length > 0 && (
                        <div style={{
                            textAlign: 'left',
                            display: 'block',
                            fontFamily: 'monospace',
                            position: 'relative',
                            padding: '10px',
                            margin: '10px 0px'
                        }}>
                            <ReactJson src={data.queryParams} name="queryParams" iconStyle="square" enableClipboard={false} collapsed={1} collapseStringsAfterLength={40}/>
                        </div>
                    )}
                </Col>
                <Col span={12}>
                    <div style={{
                        textAlign: 'left',
                        display: 'block',
                        fontFamily: 'monospace',
                        position: 'relative',
                        padding: '0px 10px',
                        margin: '10px 0px'
                    }}>
                        <ReactJson src={data.body || {}} name="body" iconStyle="square" enableClipboard={false} collapsed={1} collapseStringsAfterLength={40}/>
                    </div>
                </Col>
            </Row>
        </div>
    </Content>
}